<template>
  <div class="data_tabs">
    <a-tabs type="card" style="background: #ffffff">
      <a-tab-pane key="1" tab="备件基础信息">
        <spare-parts-detail ref="sparePartsDetail" :model="model"></spare-parts-detail>
      </a-tab-pane>
      <a-tab-pane key="2" tab="库存信息">
        <inventory-information ref="inventoryInformation" :model="model"></inventory-information>
      </a-tab-pane>
      <a-tab-pane key="3" tab="履历信息">
        <resume-information ref="resumeInformation" :model="model"></resume-information>
      </a-tab-pane>
      <a-tab-pane key="4" tab="关联设备">
        <associated-device ref="associatedDevice" :model="model"></associated-device>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>

<script>
import InventoryInformation from './inventoryInformation.vue'
import sparePartsDetail from './sparePartsDetail.vue'
import resumeInformation from './resumeInformation.vue'
import associatedDevice from './associatedDevice.vue'
export default {
  props: {
    model: Object
  },
  components: {
    InventoryInformation,
    sparePartsDetail,
    resumeInformation,
    associatedDevice
  },
  data  () {
    return {}
  },
  methods: {}
}
</script>

<style lang="less" scoped>
.data_tabs {
  /deep/.ant-tabs-bar {
    border: 0;
    margin-bottom: 0;
    .ant-tabs-nav-container {
      padding-left: 8px;
      border-bottom: 1px solid #DDDDDD;
      // border: 0;

      .ant-tabs-tab {
        border: 0;
        height: 26px;
        line-height: 26px;
        padding: 0 10px;
        margin: 7px 0;
        margin-right: 16px;
        font-family: SourceHanSansCN-Medium, SourceHanSansCN;
        font-weight: 500;
      }
      .ant-tabs-tab-active {
        color: #1791FF;
        background: rgba(23, 145, 255, 0.1);
      }
    }
  }

  // /deep/.ant-tabs-tab{
  //   border: 0 !important;
  //   height: 26px !important;
  //   line-height: 26px !important;
  //   padding: 0 10px !important;
  //   margin: 7px 0 !important;
  //   margin-right: 16px !important;
  // }
  // /deep/.ant-tabs-tab-active{
  //   background: rgba(23, 145, 255, 0.1) !important;
  // }
}
</style>
